import { BaseDto } from "../base/baseDto.model";
import { CabeceraComprobanteDto } from "./cabeceraComprobanteDto.model";
import { DetalleComprobanteDetailDto } from "./detalleComprobanteDetailDto.model";

export class ComprobanteDetailDto extends BaseDto{
  public cabeceraComprobante!: CabeceraComprobanteDto
  public detalleComprobante!: DetalleComprobanteDetailDto[]
  public importeTotalComprobante!:number
}
